module.exports = __webpack_public_path__ + "static/stand.24277b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/za/integrations/images/stand.png
// module id = 1594
// module chunks = 279379153958506